import type { CSSProperties } from "react";

export type LegendShape = "square" | "line" | "dot" | "ring";

export interface LegendItem {
	label: string;
	/** CSS rang ifodasi — `holatVar()` yoki `var(--chart-*)`, hex EMAS. */
	color: string;
	/**
	 * ⚠️ **Relief qoidasi (spec §2.1):** `uzrli` kabi past kontrastli
	 * rang bilan chizilgan segmentning legendasida qiymat MAJBURIY.
	 */
	value?: string;
	shape?: LegendShape;
}

export interface LegendProps {
	items: LegendItem[];
}

function belgiUslubi(shape: LegendShape, color: string): CSSProperties {
	switch (shape) {
		case "line":
			return { width: 14, height: 2, backgroundColor: color, borderRadius: 1 };
		case "dot":
			return { width: 8, height: 8, backgroundColor: color, borderRadius: "50%" };
		case "ring":
			return {
				width: 8,
				height: 8,
				border: `2px solid ${color}`,
				borderRadius: "50%",
				boxSizing: "border-box",
			};
		default:
			return { width: 8, height: 8, backgroundColor: color, borderRadius: 2 };
	}
}

/**
 * Diagramma legendasi.
 *
 * ⚠️ Rang YOLG'IZ ma'no tashimaydi — har element yorliq bilan, kerak
 * bo'lsa qiymat bilan.
 */
export function Legend({ items }: LegendProps) {
	return (
		<ul className="m-0 flex list-none flex-wrap gap-x-4 gap-y-1 p-0 text-xs">
			{items.map((item) => {
				const shape = item.shape ?? "square";

				return (
					<li
						key={`${item.label}-${item.color}`}
						data-legend-item
						className="flex items-center gap-1.5"
						style={{ color: "var(--chart-ink)" }}
					>
						<span
							data-legend-swatch
							data-shape={shape}
							aria-hidden="true"
							className="inline-block shrink-0"
							style={belgiUslubi(shape, item.color)}
						/>
						<span>{item.label}</span>
						{item.value === undefined ? null : (
							<strong data-legend-value className="tabular-nums">
								{item.value}
							</strong>
						)}
					</li>
				);
			})}
		</ul>
	);
}
